<template>
    <div class="row">
      <div class="col-md-12">
        <b-form @submit.prevent.stop="onSubmit" @reset.prevent.stop="onReset" novalidate="novalidate">
          <div class="card">
            <div class="card-header card-header-icon card-header-rose">
              <div class="card-icon" v-b-toggle.filter>
                <i class="material-icons">search</i>
              </div>
              <h4 class="card-title">Filtros</h4>
            </div>
            <br />
            <b-collapse id="filter">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <input
                      type="text"
                      placeholder="Buscar por Nome, CPF ou contrato." 
                      name="name" 
                      v-model="form.name" 
                      class="form-control" 
                      id="name" 
                      autocomplete="off" 
                      @input="findDataText(form.name)" />
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <button type="reset" class="btn btn-fill btn-outline-danger">Limpar Filtros</button>
                <!-- <button type="submit" class="btn btn-fill btn-rose">Filtrar</button> -->
              </div>
            </b-collapse>
          </div>
        </b-form>
      </div>
    </div>
</template>

<script>
    export default {
      data(){
            return {
                form : {
                    id : null,
                    name : null,
                    administrator_id : null,
                    textSearch : ''
                }
            }
        },
        computed: {
            administrators(){
              return this.$store.state.administrators.itens;
            }
        },
        created(){
          this.getAdministrators();
        },
        methods : {
            onReset(e){
                this.form.id         = '';
                this.form.name       = '';
                this.form.administrator_id = '';

                this.$emit('resetFilters');
            },
            findDataText( name ){
              this.form.id         = '';
              this.form.administrator_id = '';
              this.$emit('filterName', name);
            },
            findDataAdministrator(id){
              this.form.name = '';
              this.form.id   = '';
              this.$emit('filterAdministrator', id);
            },
            async getAdministrators() {
                var self = this;

                self.$root.$emit('onLoading');

                const response = self.$store.dispatch('administrators/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            }
    }
  }
</script>